import { Link } from "react-router-dom";
import BaseLayout from "../components/layout/BaseLayout";
import { MdOutlineEmail } from "react-icons/md";

const Contact = () => (
  <BaseLayout>
    <div className="flex flex-col items-center bg-white py-10">
      <div className="text-xl text-gray-600 mb-5 max-w-[900px]">
        <h3 className="text-2xl md:text-3xl font-semibold text-gray-900 mb-4">Haben Sie Fragen oder benötigen Sie Unterstützung?</h3>
        <p className="text-gray-600 text-base md:text-lg">
          Unser Team von <strong>Ackerplus</strong> ist gerne für Sie da.  
        Ob Sie technische Hilfe benötigen, Feedback geben oder einfach mehr über unsere Lösungen erfahren möchten –  
        wir freuen uns, von Ihnen zu hören.
        </p>
      </div>

      <div className="flex justify-center gap-8 flex-wrap mt-5">
        <div className="bg-white flex flex-1 flex-col gap-3 items-center p-7 pt-5 w-80 md:w-96 cursor-pointer rounded-xl subscription-option border-2 border-gray-300 text-center">
          <MdOutlineEmail size={60} color="#37813b" />
          <h3 className="text-lg font-medium text-gray-500 m-0">E-Mail</h3>
          <h3 className="text-xl font-bold my-1">Schreiben Sie uns – wir melden uns schnellstmöglich bei Ihnen.</h3>

          <Link to='mailto:hello@ackerplus.ch' className="bg-[#2F4F2F] hover:bg-[#37813b] text-white text-base font-medium py-2.5 px-14 rounded-lg transition-colors">
            Kontakt aufnehmen
          </Link>
        </div>
      </div>
    </div>
  </BaseLayout>
);

export default Contact;
